module.exports = __webpack_public_path__ + "img/screen_2_questions.738fdd99.png";